/* tslint:disable */
/* eslint-disable */
/**
 * 不系舟 (lfr-unmoored) API
 * Family Hub 后端 API — Go 重写版。  Phase 2 codegen-ready 版本（SPEC-1..SPEC-9 完成）： - 全 path 带 operationId（驼峰命名） - 4xx/5xx 统一响应 ErrorResponse - 时间字段统一 date-time（RFC3339） - schema 标 required - request body 抽出命名 schema（XxxCreateRequest / XxxUpdateRequest） - v2.1.1 (BE-S5-002): content/text 字段加 description，明确语义边界 - v2.6.0 (BE-S11-001): 新增日程模块 /api/schedule/items（单日/区间查询、单条 CRUD、   批量整周替换、DDL 截止前一天提醒），数据按 X-User 隔离 - v2.7.0 (BE-TD-001): 既有漂移治理——补齐 68 个已上线 BE 路由（okr/memo/meetings/   tasks/shares/packing/travel/health/growth/agent/metrics/auth/todo 13 域），   listGrowth 返回类型修正为 map（对齐生产实现），spec ↔ BE 恢复 1:1 - v2.8.0: 日程新增 meal 类型；training / meal 通过 note 传递结构化计划详情 - v2.9.0: 日程新增 category 字段，删除「其他」兜底分区；所有事项必须归类为   timeline|work_plan|training_plan|meal_plan|life - v2.10.0: 新增自省语录 /api/okr/reflection（与 /api/okr/backdrop 同构，独立表） - v2.11.0 (PRD v3 待办+日程合并): /api/work/todo 升级为统一任务查询——新增   date/from/to 日历区间、status（含 overdue/held/pending 特殊口径）、type/tag 过滤，   新增 GET /api/work/todo/{id}；Todo schema 补 type/category/tag/url/startDate/   deadline/time/remindBefore/remindedAt/heldSince/createdAt/updatedAt，status 统一   6 值枚举（in_progress 下划线）；/api/schedule/items 转为过渡期别名（数据源=todos   单表，响应契约不变，标记 deprecated） 
 *
 * The version of the OpenAPI document: 2.13.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { ListStrengthLogs200Response } from '../models';
// @ts-ignore
import type { StrengthConfig } from '../models';
// @ts-ignore
import type { StrengthLog } from '../models';
// @ts-ignore
import type { StrengthLogCreateRequest } from '../models';
// @ts-ignore
import type { StrengthPlan } from '../models';
// @ts-ignore
import type { StrengthPlanCreateRequest } from '../models';
// @ts-ignore
import type { SyncResponse } from '../models';
/**
 * StrengthApi - axios parameter creator
 * @export
 */
export const StrengthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create strength training log
         * @param {StrengthLogCreateRequest} strengthLogCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStrengthLog: async (strengthLogCreateRequest: StrengthLogCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'strengthLogCreateRequest' is not null or undefined
            assertParamExists('createStrengthLog', 'strengthLogCreateRequest', strengthLogCreateRequest)
            const localVarPath = `/api/health/strength/logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication XUser required
            await setApiKeyToObject(localVarHeaderParameter, "X-User", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(strengthLogCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create strength training plan
         * @param {StrengthPlanCreateRequest} strengthPlanCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStrengthPlan: async (strengthPlanCreateRequest: StrengthPlanCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'strengthPlanCreateRequest' is not null or undefined
            assertParamExists('createStrengthPlan', 'strengthPlanCreateRequest', strengthPlanCreateRequest)
            const localVarPath = `/api/health/strength/plans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication XUser required
            await setApiKeyToObject(localVarHeaderParameter, "X-User", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(strengthPlanCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete strength log
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStrengthLog: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteStrengthLog', 'id', id)
            const localVarPath = `/api/health/strength/logs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication XUser required
            await setApiKeyToObject(localVarHeaderParameter, "X-User", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete strength plan
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStrengthPlan: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteStrengthPlan', 'id', id)
            const localVarPath = `/api/health/strength/plans/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication XUser required
            await setApiKeyToObject(localVarHeaderParameter, "X-User", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get current active strength plan
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentStrengthPlan: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/health/strength/plans/current`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication XUser required
            await setApiKeyToObject(localVarHeaderParameter, "X-User", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get strength training config (muscles + exercises + equipment)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStrengthConfig: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/health/strength/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication XUser required
            await setApiKeyToObject(localVarHeaderParameter, "X-User", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get strength plan by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStrengthPlan: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getStrengthPlan', 'id', id)
            const localVarPath = `/api/health/strength/plans/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication XUser required
            await setApiKeyToObject(localVarHeaderParameter, "X-User", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List strength training logs (sorted by date desc)
         * @param {string} [cursor] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStrengthLogs: async (cursor?: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/health/strength/logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication XUser required
            await setApiKeyToObject(localVarHeaderParameter, "X-User", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List strength training plans
         * @param {ListStrengthPlansStatusEnum} [status] 
         * @param {string} [week] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStrengthPlans: async (status?: ListStrengthPlansStatusEnum, week?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/health/strength/plans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication XUser required
            await setApiKeyToObject(localVarHeaderParameter, "X-User", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (week !== undefined) {
                localVarQueryParameter['week'] = week;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Bulk sync strength logs (idempotent by id)
         * @param {Array<StrengthLog>} strengthLog 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncStrengthLogs: async (strengthLog: Array<StrengthLog>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'strengthLog' is not null or undefined
            assertParamExists('syncStrengthLogs', 'strengthLog', strengthLog)
            const localVarPath = `/api/health/strength/logs/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication XUser required
            await setApiKeyToObject(localVarHeaderParameter, "X-User", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(strengthLog, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update strength log
         * @param {string} id 
         * @param {StrengthLogCreateRequest} strengthLogCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStrengthLog: async (id: string, strengthLogCreateRequest: StrengthLogCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateStrengthLog', 'id', id)
            // verify required parameter 'strengthLogCreateRequest' is not null or undefined
            assertParamExists('updateStrengthLog', 'strengthLogCreateRequest', strengthLogCreateRequest)
            const localVarPath = `/api/health/strength/logs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication XUser required
            await setApiKeyToObject(localVarHeaderParameter, "X-User", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(strengthLogCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update strength plan
         * @param {string} id 
         * @param {StrengthPlanCreateRequest} strengthPlanCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStrengthPlan: async (id: string, strengthPlanCreateRequest: StrengthPlanCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateStrengthPlan', 'id', id)
            // verify required parameter 'strengthPlanCreateRequest' is not null or undefined
            assertParamExists('updateStrengthPlan', 'strengthPlanCreateRequest', strengthPlanCreateRequest)
            const localVarPath = `/api/health/strength/plans/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication XUser required
            await setApiKeyToObject(localVarHeaderParameter, "X-User", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(strengthPlanCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StrengthApi - functional programming interface
 * @export
 */
export const StrengthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StrengthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create strength training log
         * @param {StrengthLogCreateRequest} strengthLogCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createStrengthLog(strengthLogCreateRequest: StrengthLogCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StrengthLog>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createStrengthLog(strengthLogCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StrengthApi.createStrengthLog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create strength training plan
         * @param {StrengthPlanCreateRequest} strengthPlanCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createStrengthPlan(strengthPlanCreateRequest: StrengthPlanCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StrengthPlan>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createStrengthPlan(strengthPlanCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StrengthApi.createStrengthPlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete strength log
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteStrengthLog(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteStrengthLog(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StrengthApi.deleteStrengthLog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete strength plan
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteStrengthPlan(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteStrengthPlan(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StrengthApi.deleteStrengthPlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get current active strength plan
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentStrengthPlan(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StrengthPlan>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentStrengthPlan(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StrengthApi.getCurrentStrengthPlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get strength training config (muscles + exercises + equipment)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStrengthConfig(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StrengthConfig>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStrengthConfig(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StrengthApi.getStrengthConfig']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get strength plan by id
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStrengthPlan(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StrengthPlan>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStrengthPlan(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StrengthApi.getStrengthPlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List strength training logs (sorted by date desc)
         * @param {string} [cursor] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listStrengthLogs(cursor?: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListStrengthLogs200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listStrengthLogs(cursor, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StrengthApi.listStrengthLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List strength training plans
         * @param {ListStrengthPlansStatusEnum} [status] 
         * @param {string} [week] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listStrengthPlans(status?: ListStrengthPlansStatusEnum, week?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<StrengthPlan>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listStrengthPlans(status, week, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StrengthApi.listStrengthPlans']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Bulk sync strength logs (idempotent by id)
         * @param {Array<StrengthLog>} strengthLog 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async syncStrengthLogs(strengthLog: Array<StrengthLog>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyncResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.syncStrengthLogs(strengthLog, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StrengthApi.syncStrengthLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update strength log
         * @param {string} id 
         * @param {StrengthLogCreateRequest} strengthLogCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStrengthLog(id: string, strengthLogCreateRequest: StrengthLogCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StrengthLog>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStrengthLog(id, strengthLogCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StrengthApi.updateStrengthLog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update strength plan
         * @param {string} id 
         * @param {StrengthPlanCreateRequest} strengthPlanCreateRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateStrengthPlan(id: string, strengthPlanCreateRequest: StrengthPlanCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StrengthPlan>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateStrengthPlan(id, strengthPlanCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['StrengthApi.updateStrengthPlan']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * StrengthApi - factory interface
 * @export
 */
export const StrengthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StrengthApiFp(configuration)
    return {
        /**
         * 
         * @summary Create strength training log
         * @param {StrengthApiCreateStrengthLogRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStrengthLog(requestParameters: StrengthApiCreateStrengthLogRequest, options?: RawAxiosRequestConfig): AxiosPromise<StrengthLog> {
            return localVarFp.createStrengthLog(requestParameters.strengthLogCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create strength training plan
         * @param {StrengthApiCreateStrengthPlanRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createStrengthPlan(requestParameters: StrengthApiCreateStrengthPlanRequest, options?: RawAxiosRequestConfig): AxiosPromise<StrengthPlan> {
            return localVarFp.createStrengthPlan(requestParameters.strengthPlanCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete strength log
         * @param {StrengthApiDeleteStrengthLogRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStrengthLog(requestParameters: StrengthApiDeleteStrengthLogRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteStrengthLog(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete strength plan
         * @param {StrengthApiDeleteStrengthPlanRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteStrengthPlan(requestParameters: StrengthApiDeleteStrengthPlanRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteStrengthPlan(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get current active strength plan
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentStrengthPlan(options?: RawAxiosRequestConfig): AxiosPromise<StrengthPlan> {
            return localVarFp.getCurrentStrengthPlan(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get strength training config (muscles + exercises + equipment)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStrengthConfig(options?: RawAxiosRequestConfig): AxiosPromise<StrengthConfig> {
            return localVarFp.getStrengthConfig(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get strength plan by id
         * @param {StrengthApiGetStrengthPlanRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStrengthPlan(requestParameters: StrengthApiGetStrengthPlanRequest, options?: RawAxiosRequestConfig): AxiosPromise<StrengthPlan> {
            return localVarFp.getStrengthPlan(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List strength training logs (sorted by date desc)
         * @param {StrengthApiListStrengthLogsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStrengthLogs(requestParameters: StrengthApiListStrengthLogsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<ListStrengthLogs200Response> {
            return localVarFp.listStrengthLogs(requestParameters.cursor, requestParameters.limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List strength training plans
         * @param {StrengthApiListStrengthPlansRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listStrengthPlans(requestParameters: StrengthApiListStrengthPlansRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<StrengthPlan>> {
            return localVarFp.listStrengthPlans(requestParameters.status, requestParameters.week, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Bulk sync strength logs (idempotent by id)
         * @param {StrengthApiSyncStrengthLogsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        syncStrengthLogs(requestParameters: StrengthApiSyncStrengthLogsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SyncResponse> {
            return localVarFp.syncStrengthLogs(requestParameters.strengthLog, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update strength log
         * @param {StrengthApiUpdateStrengthLogRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStrengthLog(requestParameters: StrengthApiUpdateStrengthLogRequest, options?: RawAxiosRequestConfig): AxiosPromise<StrengthLog> {
            return localVarFp.updateStrengthLog(requestParameters.id, requestParameters.strengthLogCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update strength plan
         * @param {StrengthApiUpdateStrengthPlanRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateStrengthPlan(requestParameters: StrengthApiUpdateStrengthPlanRequest, options?: RawAxiosRequestConfig): AxiosPromise<StrengthPlan> {
            return localVarFp.updateStrengthPlan(requestParameters.id, requestParameters.strengthPlanCreateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StrengthApi - interface
 * @export
 * @interface StrengthApi
 */
export interface StrengthApiInterface {
    /**
     * 
     * @summary Create strength training log
     * @param {StrengthApiCreateStrengthLogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StrengthApiInterface
     */
    createStrengthLog(requestParameters: StrengthApiCreateStrengthLogRequest, options?: RawAxiosRequestConfig): AxiosPromise<StrengthLog>;

    /**
     * 
     * @summary Create strength training plan
     * @param {StrengthApiCreateStrengthPlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StrengthApiInterface
     */
    createStrengthPlan(requestParameters: StrengthApiCreateStrengthPlanRequest, options?: RawAxiosRequestConfig): AxiosPromise<StrengthPlan>;

    /**
     * 
     * @summary Delete strength log
     * @param {StrengthApiDeleteStrengthLogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StrengthApiInterface
     */
    deleteStrengthLog(requestParameters: StrengthApiDeleteStrengthLogRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Delete strength plan
     * @param {StrengthApiDeleteStrengthPlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StrengthApiInterface
     */
    deleteStrengthPlan(requestParameters: StrengthApiDeleteStrengthPlanRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Get current active strength plan
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StrengthApiInterface
     */
    getCurrentStrengthPlan(options?: RawAxiosRequestConfig): AxiosPromise<StrengthPlan>;

    /**
     * 
     * @summary Get strength training config (muscles + exercises + equipment)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StrengthApiInterface
     */
    getStrengthConfig(options?: RawAxiosRequestConfig): AxiosPromise<StrengthConfig>;

    /**
     * 
     * @summary Get strength plan by id
     * @param {StrengthApiGetStrengthPlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StrengthApiInterface
     */
    getStrengthPlan(requestParameters: StrengthApiGetStrengthPlanRequest, options?: RawAxiosRequestConfig): AxiosPromise<StrengthPlan>;

    /**
     * 
     * @summary List strength training logs (sorted by date desc)
     * @param {StrengthApiListStrengthLogsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StrengthApiInterface
     */
    listStrengthLogs(requestParameters?: StrengthApiListStrengthLogsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListStrengthLogs200Response>;

    /**
     * 
     * @summary List strength training plans
     * @param {StrengthApiListStrengthPlansRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StrengthApiInterface
     */
    listStrengthPlans(requestParameters?: StrengthApiListStrengthPlansRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<StrengthPlan>>;

    /**
     * 
     * @summary Bulk sync strength logs (idempotent by id)
     * @param {StrengthApiSyncStrengthLogsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StrengthApiInterface
     */
    syncStrengthLogs(requestParameters: StrengthApiSyncStrengthLogsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SyncResponse>;

    /**
     * 
     * @summary Update strength log
     * @param {StrengthApiUpdateStrengthLogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StrengthApiInterface
     */
    updateStrengthLog(requestParameters: StrengthApiUpdateStrengthLogRequest, options?: RawAxiosRequestConfig): AxiosPromise<StrengthLog>;

    /**
     * 
     * @summary Update strength plan
     * @param {StrengthApiUpdateStrengthPlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StrengthApiInterface
     */
    updateStrengthPlan(requestParameters: StrengthApiUpdateStrengthPlanRequest, options?: RawAxiosRequestConfig): AxiosPromise<StrengthPlan>;

}

/**
 * Request parameters for createStrengthLog operation in StrengthApi.
 * @export
 * @interface StrengthApiCreateStrengthLogRequest
 */
export interface StrengthApiCreateStrengthLogRequest {
    /**
     * 
     * @type {StrengthLogCreateRequest}
     * @memberof StrengthApiCreateStrengthLog
     */
    readonly strengthLogCreateRequest: StrengthLogCreateRequest
}

/**
 * Request parameters for createStrengthPlan operation in StrengthApi.
 * @export
 * @interface StrengthApiCreateStrengthPlanRequest
 */
export interface StrengthApiCreateStrengthPlanRequest {
    /**
     * 
     * @type {StrengthPlanCreateRequest}
     * @memberof StrengthApiCreateStrengthPlan
     */
    readonly strengthPlanCreateRequest: StrengthPlanCreateRequest
}

/**
 * Request parameters for deleteStrengthLog operation in StrengthApi.
 * @export
 * @interface StrengthApiDeleteStrengthLogRequest
 */
export interface StrengthApiDeleteStrengthLogRequest {
    /**
     * 
     * @type {string}
     * @memberof StrengthApiDeleteStrengthLog
     */
    readonly id: string
}

/**
 * Request parameters for deleteStrengthPlan operation in StrengthApi.
 * @export
 * @interface StrengthApiDeleteStrengthPlanRequest
 */
export interface StrengthApiDeleteStrengthPlanRequest {
    /**
     * 
     * @type {string}
     * @memberof StrengthApiDeleteStrengthPlan
     */
    readonly id: string
}

/**
 * Request parameters for getStrengthPlan operation in StrengthApi.
 * @export
 * @interface StrengthApiGetStrengthPlanRequest
 */
export interface StrengthApiGetStrengthPlanRequest {
    /**
     * 
     * @type {string}
     * @memberof StrengthApiGetStrengthPlan
     */
    readonly id: string
}

/**
 * Request parameters for listStrengthLogs operation in StrengthApi.
 * @export
 * @interface StrengthApiListStrengthLogsRequest
 */
export interface StrengthApiListStrengthLogsRequest {
    /**
     * 
     * @type {string}
     * @memberof StrengthApiListStrengthLogs
     */
    readonly cursor?: string

    /**
     * 
     * @type {number}
     * @memberof StrengthApiListStrengthLogs
     */
    readonly limit?: number
}

/**
 * Request parameters for listStrengthPlans operation in StrengthApi.
 * @export
 * @interface StrengthApiListStrengthPlansRequest
 */
export interface StrengthApiListStrengthPlansRequest {
    /**
     * 
     * @type {'active' | 'completed' | 'cancelled'}
     * @memberof StrengthApiListStrengthPlans
     */
    readonly status?: ListStrengthPlansStatusEnum

    /**
     * 
     * @type {string}
     * @memberof StrengthApiListStrengthPlans
     */
    readonly week?: string
}

/**
 * Request parameters for syncStrengthLogs operation in StrengthApi.
 * @export
 * @interface StrengthApiSyncStrengthLogsRequest
 */
export interface StrengthApiSyncStrengthLogsRequest {
    /**
     * 
     * @type {Array<StrengthLog>}
     * @memberof StrengthApiSyncStrengthLogs
     */
    readonly strengthLog: Array<StrengthLog>
}

/**
 * Request parameters for updateStrengthLog operation in StrengthApi.
 * @export
 * @interface StrengthApiUpdateStrengthLogRequest
 */
export interface StrengthApiUpdateStrengthLogRequest {
    /**
     * 
     * @type {string}
     * @memberof StrengthApiUpdateStrengthLog
     */
    readonly id: string

    /**
     * 
     * @type {StrengthLogCreateRequest}
     * @memberof StrengthApiUpdateStrengthLog
     */
    readonly strengthLogCreateRequest: StrengthLogCreateRequest
}

/**
 * Request parameters for updateStrengthPlan operation in StrengthApi.
 * @export
 * @interface StrengthApiUpdateStrengthPlanRequest
 */
export interface StrengthApiUpdateStrengthPlanRequest {
    /**
     * 
     * @type {string}
     * @memberof StrengthApiUpdateStrengthPlan
     */
    readonly id: string

    /**
     * 
     * @type {StrengthPlanCreateRequest}
     * @memberof StrengthApiUpdateStrengthPlan
     */
    readonly strengthPlanCreateRequest: StrengthPlanCreateRequest
}

/**
 * StrengthApi - object-oriented interface
 * @export
 * @class StrengthApi
 * @extends {BaseAPI}
 */
export class StrengthApi extends BaseAPI implements StrengthApiInterface {
    /**
     * 
     * @summary Create strength training log
     * @param {StrengthApiCreateStrengthLogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StrengthApi
     */
    public createStrengthLog(requestParameters: StrengthApiCreateStrengthLogRequest, options?: RawAxiosRequestConfig) {
        return StrengthApiFp(this.configuration).createStrengthLog(requestParameters.strengthLogCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create strength training plan
     * @param {StrengthApiCreateStrengthPlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StrengthApi
     */
    public createStrengthPlan(requestParameters: StrengthApiCreateStrengthPlanRequest, options?: RawAxiosRequestConfig) {
        return StrengthApiFp(this.configuration).createStrengthPlan(requestParameters.strengthPlanCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete strength log
     * @param {StrengthApiDeleteStrengthLogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StrengthApi
     */
    public deleteStrengthLog(requestParameters: StrengthApiDeleteStrengthLogRequest, options?: RawAxiosRequestConfig) {
        return StrengthApiFp(this.configuration).deleteStrengthLog(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete strength plan
     * @param {StrengthApiDeleteStrengthPlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StrengthApi
     */
    public deleteStrengthPlan(requestParameters: StrengthApiDeleteStrengthPlanRequest, options?: RawAxiosRequestConfig) {
        return StrengthApiFp(this.configuration).deleteStrengthPlan(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get current active strength plan
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StrengthApi
     */
    public getCurrentStrengthPlan(options?: RawAxiosRequestConfig) {
        return StrengthApiFp(this.configuration).getCurrentStrengthPlan(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get strength training config (muscles + exercises + equipment)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StrengthApi
     */
    public getStrengthConfig(options?: RawAxiosRequestConfig) {
        return StrengthApiFp(this.configuration).getStrengthConfig(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get strength plan by id
     * @param {StrengthApiGetStrengthPlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StrengthApi
     */
    public getStrengthPlan(requestParameters: StrengthApiGetStrengthPlanRequest, options?: RawAxiosRequestConfig) {
        return StrengthApiFp(this.configuration).getStrengthPlan(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List strength training logs (sorted by date desc)
     * @param {StrengthApiListStrengthLogsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StrengthApi
     */
    public listStrengthLogs(requestParameters: StrengthApiListStrengthLogsRequest = {}, options?: RawAxiosRequestConfig) {
        return StrengthApiFp(this.configuration).listStrengthLogs(requestParameters.cursor, requestParameters.limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List strength training plans
     * @param {StrengthApiListStrengthPlansRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StrengthApi
     */
    public listStrengthPlans(requestParameters: StrengthApiListStrengthPlansRequest = {}, options?: RawAxiosRequestConfig) {
        return StrengthApiFp(this.configuration).listStrengthPlans(requestParameters.status, requestParameters.week, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Bulk sync strength logs (idempotent by id)
     * @param {StrengthApiSyncStrengthLogsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StrengthApi
     */
    public syncStrengthLogs(requestParameters: StrengthApiSyncStrengthLogsRequest, options?: RawAxiosRequestConfig) {
        return StrengthApiFp(this.configuration).syncStrengthLogs(requestParameters.strengthLog, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update strength log
     * @param {StrengthApiUpdateStrengthLogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StrengthApi
     */
    public updateStrengthLog(requestParameters: StrengthApiUpdateStrengthLogRequest, options?: RawAxiosRequestConfig) {
        return StrengthApiFp(this.configuration).updateStrengthLog(requestParameters.id, requestParameters.strengthLogCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update strength plan
     * @param {StrengthApiUpdateStrengthPlanRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StrengthApi
     */
    public updateStrengthPlan(requestParameters: StrengthApiUpdateStrengthPlanRequest, options?: RawAxiosRequestConfig) {
        return StrengthApiFp(this.configuration).updateStrengthPlan(requestParameters.id, requestParameters.strengthPlanCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
  * @export
  * @enum {string}
  */
export enum ListStrengthPlansStatusEnum {
    ACTIVE = 'active',
    COMPLETED = 'completed',
    CANCELLED = 'cancelled'
}
